export const NEXT_CONFIG_FILES = ['next.config.ts', 'next.config.js', 'next.config.mjs']
export const OXLINT_CONFIG_FILES = [
  '.oxlintrc.json',
  '.oxlintrc.jsonc',
  '.oxfmtrc.json',
  '.oxfmtrc.jsonc'
]
export const BIOME_CONFIG_FILES = ['biome.json', 'biome.jsonc']
export const ESLINT_CONFIG_FILES = [
  'eslint.config.js',
  'eslint.config.mjs',
  'eslint.config.cjs',
  'eslint.config.ts',
  '.eslintrc.json',
  '.eslintrc.js',
  '.eslintrc.cjs',
  '.eslintrc.yml',
  '.eslintrc.yaml',
  '.eslintrc'
]
export const OXFMT_CONFIG_FILE = '.oxfmtrc.json'
export const OXLINT_CONFIG_FILE = '.oxlintrc.json'
export const IGNORE_PATTERNS = [
  '**/node_modules/**',
  '**/.next/**',
  '**/dist/**',
  '**/build/**',
  '**/out/**',
  '**/coverage/**',
  '**/.turbo/**',
  '**/.vercel/**',
  '**/.betterstart/snapshots/**/files/**',
  '**/*.tsbuildinfo',
  '**/next-env.d.ts'
]
export const OXFMT_FORMATTABLE_EXTENSIONS = new Set([
  '.cjs',
  '.cts',
  '.js',
  '.json',
  '.jsonc',
  '.jsx',
  '.mjs',
  '.mts',
  '.ts',
  '.tsx'
])
